import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-citizens-for-impact',
  template: '<router-outlet></router-outlet>'
})
export class CitizensForImpactComponent implements OnInit {
  constructor() { }
  ngOnInit() { }
}
